// © 2023 Amazon Web Services, Inc. or its affiliates. All Rights Reserved.
// This AWS Content is provided subject to the terms of the AWS Customer Agreement available at
// http://aws.amazon.com/agreement or other written agreement between Customer and either
// Amazon Web Services, Inc. or Amazon Web Services EMEA SARL or both.
import React, { useEffect, useState } from "react";
import { Amplify, Auth, Hub } from "aws-amplify";
import awsconfig from "./aws-exports";
import Nav from "./components/Navigation/Nav";
import "./index.css";

Amplify.configure(awsconfig);

function Home({ loading }) {
  return (
    <div className="login-page">
      {loading ? (
        <div className="login-spinner">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="20" stroke="rgba(255,255,255,0.2)" strokeWidth="4" />
            <path
              d="M44 24c0-11.046-8.954-20-20-20"
              stroke="#C9A227"
              strokeWidth="4"
              strokeLinecap="round"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 24 24"
                to="360 24 24"
                dur="0.8s"
                repeatCount="indefinite"
              />
            </path>
          </svg>
          <span>Signing you in...</span>
        </div>
      ) : (
        <div className="login-card">
          {/* Logo */}
          <img
            className="login-logo"
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="Gotham Sports"
          />

          <h1 className="login-title">Access Management</h1>
          <p className="login-subtitle">
            Secure, time-bound elevated access to your cloud environment
          </p>

          <button
            className="login-btn"
            onClick={() => Auth.federatedSignIn({ customProvider: "IAMIdentityCenter" })}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M10 2L2 6v4c0 4.42 3.4 8.56 8 10 4.6-1.44 8-5.58 8-10V6l-8-4z"
                fill="currentColor"
                opacity="0.3"
              />
              <path
                d="M10 2L2 6v4c0 4.42 3.4 8.56 8 10 4.6-1.44 8-5.58 8-10V6l-8-4z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
                fill="none"
              />
              <path d="M7 10l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Sign In with SSO
          </button>

          <p className="login-footer">
            Powered by AWS IAM Identity Center
          </p>
        </div>
      )}
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [groups, setGroups] = useState(null);
  const [cognitoGroups, setcognitoGroups] = useState([]);
  const [userId, setUserId] = useState(null);
  const [groupIds, setGroupIds] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Hub.listen("auth", ({ payload: { event, data } }) => {
      // eslint-disable-next-line default-case
      switch (event) {
        case "signIn":
          console.log("User signed in");
          break;
        // eslint-disable-next-line no-fallthrough
        case "cognitoHostedUI":
          setData();
          break;
        case "signOut":
          console.log("User signed out");
          setLoading(false);
          break;
        case "signIn_failure":
          console.log("User sign in failure");
          break;
        case "cognitoHostedUI_failure":
          console.log("Sign in failure");
          break;
      }
    });

    setData();
  }, []);

  function setData() {
    getUser().then((userData) => {
      setUser(userData);
      const payload = userData.signInUserSession.idToken.payload;
      setcognitoGroups(payload["cognito:groups"]);
      setUserId(payload.userId);
      setGroupIds((payload.groupIds).split(','));
      setGroups((payload.groups).split(','));
      setLoading(false);
    });
  }

  async function getUser() {
    try {
      const userData = await Auth.currentAuthenticatedUser();
      return userData;
    } catch {
      setLoading(false);
      return console.log("Not signed in");
    }
  }

  return (
    <div>
      {groups ? (
        <Nav
          user={user}
          groupIds={groupIds}
          userId={userId}
          groups={groups}
          cognitoGroups={cognitoGroups}
        />
      ) : (
        <Home loading={loading} />
      )}
    </div>
  );
}

export default App;
